<app-navbar></app-navbar>

<section class="py-20 md:py-24 xl:py-32 min-h-[50dvh] bg-white text-black">
    <div class="container mx-auto px-4">
        <h1 class="text-2xl">{{texts.titulo}}</h1>
        <div>
            <p class="py-1">{{texts.introduccion}}</p>
            <p class="py-1">{{texts.recopilacion_datos}}</p>
            <p class="py-1">{{texts.uso_datos}}</p>
            <p class="py-1">{{texts.proteccion_datos}}</p>
            <p class="py-1">{{texts.terceros}}</p>
            <p class="py-1">{{texts.derechos_usuario}}</p>
            <p class="py-1">{{texts.contacto}}</p>
        </div>
    </div>
</section>


<app-footer></app-footer>

